module.exports = __webpack_public_path__ + "static/media/plus.47c50c28.svg";